<template>
  <div id="func-16">
    <FuncionalidadeHeader
      :titulo="tituloNavegacao"
    />
    <solicitacao-detalhe/>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoDetalhe from '@/components/TemplateSolicitacao/componentes/SolicitacaoDetalhe'
import { mapState } from 'vuex'
export default {
  name: 'Func16Detalhe',
  components: {
    SolicitacaoDetalhe,
    FuncionalidadeHeader
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiSolicitacao']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.tituloTelaDetalhe
    }
  }
}
</script>
